import { lightTheme } from 'styling/GlobalStyles'

// lists for ReactSelect value
export const genderList = [
  { value: 'm', label: 'Male' },
  { value: 'f', label: 'Female' },
]
export const accessTypeList = [
  { value: 'manager', label: 'Manager' },
  { value: 'worker', label: 'Worker' },
  { value: 'supervisor', label: 'Supervisor' },
  { value: 'contractor', label: 'Contractor' },
]
export const driverLicense = [
  { value: null, label: 'None' },
  { value: 'a', label: 'A' },
  { value: 'b', label: 'B' },
  { value: 'c', label: 'C' },
  { value: 'd', label: 'D' },
]
export const maritalStatus = [
  { value: 'married', label: 'Married' },
  { value: 'single', label: 'Single' },
]

export const contractIndefiniteList = [
  { value: 'indefinite', label: 'Indefinite' },
  { value: 'definite', label: 'Definite' },
]

// end of lists for ReactSelect value

// chart colors
export const greenChartColors = [`${lightTheme.greenChart}`, `${lightTheme.grayChart}`]
export const brownChartColors = [`${lightTheme.brownChart}`, `${lightTheme.grayChart}`]
export const blueChartColors = [`${lightTheme.blueChart}`, `${lightTheme.grayChart}`]
export const redChartColors = [`${lightTheme.redChart}`, `${lightTheme.grayChart}`]

// funcs
export const modifiedStats = (name, state) => {
  // this data is modified as to create 2 values that would display in graph
  // problem with current lib is that you can't set 100% and compare one value with it

  let userStats
  const values = { ...state }

  switch (name) {
    case 'active':
      userStats = [
        { name: 'Active Workers', value: values.active },
        { name: 'Total Workers', value: values.totalWorkers },
      ]
      userStats = userStats.map((i) => {
        if (i.name === 'Total Workers') {
          const [activeWorkers, totalWorkers] = userStats
          const result = totalWorkers.value - activeWorkers.value

          return { name: 'Total Workers', value: result }
        }
        return i
      })

      return userStats

    case 'vacation':
      userStats = [
        { name: 'Workers On Vacation', value: values.vacation },
        { name: 'Total Workers', value: values.totalWorkers },
      ]
      userStats = userStats.map((i) => {
        if (i.name === 'Total Workers') {
          const [activeWorkers, totalWorkers] = userStats
          const result = totalWorkers.value - activeWorkers.value
          return { name: 'Total Workers', value: result }
        }
        return i
      })
      return userStats

    case 'sick':
      userStats = [
        { name: 'Workers On Sick Relief', value: values.sickLeave },
        { name: 'Total Workers', value: values.totalWorkers },
      ]
      userStats = userStats.map((i) => {
        if (i.name === 'Total Workers') {
          const [activeWorkers, totalWorkers] = userStats
          const result = totalWorkers.value - activeWorkers.value
          return { name: 'Total Workers', value: result }
        }
        return i
      })
      return userStats

    default:
      break
  }
}

export const originStats = (title, values) => {
  const stats = [{ name: 'Total Workers', value: values?.totalWorkers }]

  const string = title.toLowerCase()

  const param = string.includes('active')
    ? 'active'
    : string.includes('sick')
    ? 'sickLeave'
    : string.includes('vacation')
    ? 'vacation'
    : ''

  stats.unshift({ name: title, value: values ? values[param] : null })

  return stats
}

// "category": "Contract = 1, IDDocument = 2, WorkPermit = 3, Certificate = 4, Medical = 5, Training = 6, Other = 7",

export const documentCategoryOptions = [
  { value: 1, label: 'Contract' },
  { value: 2, label: 'ID Document' },
  { value: 3, label: 'Work Permit' },
  { value: 4, label: 'Certificate' },
  { value: 5, label: 'Medical' },
  { value: 6, label: 'Training' },
  { value: 7, label: 'Other' },
]

// "accessRestrictions": "Private = 1, Restricted = 2, Internal = 3",

export const documentAccessRestrictionsOptions = [
  { value: 1, label: 'Private' },
  { value: 2, label: 'Restricted' },
  { value: 3, label: 'Internal' },
]

// "Contract = 1, IDDocument = 2, WorkPermit = 3, Certificate = 4, Medical = 5, Training = 6, Other = 7",
export const noteVisibilityScopeOptions = [
  { value: 1, label: 'Restricted' },
  { value: 2, label: 'General' },
]

export const noteCategoryOptions = [
  { value: 1, label: 'HR' },
  { value: 2, label: 'Ops' },
  { value: 3, label: 'Compliance' },
  { value: 4, label: 'Welfare' },
]
